import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import RestaurantCard from "../../components/RestaurantCard";
import { fetchRestaurants } from "../../store/restaurants/actions";
import { selectRestaurants } from "../../store/restaurants/selectors";

import "./style.css";

export default function RestaurantList(props) {
  const dispatch = useDispatch();
  const restaurants = useSelector(selectRestaurants);
  const city = props.city;

  //   console.log("1", selectRestaurants);
  console.log("city", city);

  useEffect(() => {
    dispatch(fetchRestaurants(city));
  }, [dispatch, city]);

  //   console.log("2", restaurants);

  return (
    <div style={{ display: "flex", flexWrap: "wrap", marginLeft: "1.5%" }}>
      {restaurants.map((restaurant) => {
        return (
          <RestaurantCard
            key={restaurant.id}
            id={restaurant.id}
            name={restaurant.name}
            rate={restaurant.rate}
            imageUrl={restaurant.imageUrl}
            showLink={true}
          />
        );
      })}
    </div>
  );
}

// import React, { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";

// import { fetchRestaurants } from "../../store/restaurants/actions";
// import { selectRestaurants } from "../../store/restaurants/selectors";
// import {
//   ImageList,
//   ImageListItem,
//   ImageListItemBar,
//   ListSubheader,
//   Rating,
// } from "@material-ui/core";
// import { Star } from "@material-ui/icons";

// export default function RestaurantList(props) {
//   const dispatch = useDispatch();
//   const restaurants = useSelector(selectRestaurants);
//   const city = props.city;

//   //   console.log("1", selectRestaurants);
//   console.log("city", city);

//   useEffect(() => {
//     dispatch(fetchRestaurants(city));
//   }, [dispatch, city]);

//   //   console.log("2", restaurants);

//   return (
//     <ImageList sx={{ width: 500, height: 450 }}>
//       <ImageListItem key="Subheader" cols={2}>
//         <ListSubheader component="div"></ListSubheader>
//       </ImageListItem>

//       {restaurants.map((restaurant) => (
//         <ImageListItem key={restaurant.id}>
//           <img
//             className="photo"
//             src={`${restaurant.imageUrl}`}
//             srcSet={`${restaurant.imageUrl}`}
//             alt={restaurant.name}
//             loading="lazy"
//           />
//           <ImageListItemBar
//             title={restaurant.name}
//             subtitle={
//               <li>
//                 {" "}
//                 {restaurant.rate}
//                 <Rating
//                   sx={{ color: "#000d30" }}
//                   value={restaurant.rate}
//                   readOnly
//                   precision={0.1}
//                   emptyIcon={<Star style={{ opacity: 0.6 }} />}
//                 />
//               </li>
//             }
//           />
//         </ImageListItem>
//       ))}
//     </ImageList>
//   );
// }
